<template>
  <div class="unit-page">
    <br />
    <h1>{{ unit.name }}</h1>
    <p>{{ unit.address }}</p>
    <p>{{ unit.appartmentNo }}</p>
    <p>{{ unit.comments }}</p>

    <router-link
      class="unit-link"
      :to="{ name: 'swipeCards', params: { unitId: unit.id } }"
    >
      <div class="add-btn">{{ $t('inventoryCheck') }}</div>
    </router-link>
    <br />
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      id: this.unit.id
    }
  },
  async created() {
  },
  methods: {
    deleteUnit() {
      if (confirm('are you sure?')) {
        this.$store.dispatch('unit/removeUnit', this.id).then(() => {
          this.$router.push({
            path: '/units'
          })
        })
        // .catch(e => console.log(e))
      }
    }
  },
  props: {
    unit: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
body {
  margin: 0;
  z-index: 0;
}

.unit-page {
  width: 100%;
}

.add-btn {
  margin: auto;
}

.unit-link:hover {
  text-decoration: none !important;
}

.add-btn-enabled {
  background: var(--primaryDark);
  color: var(--bright);
}

.add-btn-disabled {
  background: grey;
  color: var(--bright);
}
</style>
